import Button from 'components/partials/button/button';
import Icons from 'assets/icons';

export const NoToplineGoals = (): React.JSX.Element => (
  <div className="flex-1 bg-navy-50 p-4 rounded-lg flex flex-col justify-center items-center">
    <p className="text-lg font-bold text-center mb-2">
      Your Topline Goals are missing.
    </p>
    <p className="text-center">
      Please contact the MARKETview success team to set them up.
    </p>
  </div>
);

interface NoGoalsDefinedProps {
  handleEmailClick: () => void;
}

export const NoGoalsDefined = ({
  handleEmailClick,
}: NoGoalsDefinedProps): React.JSX.Element => (
  <div className="h-full bg-navy-800 rounded-lg flex flex-col items-center justify-center text-center p-5 pt-0">
    <p className="text-white font-bold text-lg">Your goals are missing.</p>

    <p className="text-white mb-5 leading-6">
      Please contact your MARKETview success team to set them up.
    </p>

    <Button
      variant="brand-filled"
      size="sm"
      onClick={handleEmailClick}
      iconAfter={<Icons.DoubleArrow />}
    >
      Speak to Us
    </Button>
  </div>
);

export const SkeletonLoader = (): React.JSX.Element => (
  <div className="h-full bg-white border border-gray-200 rounded-lg flex flex-col p-5 animate-pulse">
    <div className="flex items-center gap-2 mb-4">
      <div className="h-5 w-5 bg-gray-300 rounded-full"></div>
      <div className="h-5 w-32 bg-gray-300 rounded"></div>
    </div>
    <div className="sr-only">Loading...</div>
    <div className="flex-1 bg-gray-50 p-4 rounded-lg flex items-center justify-center">
      <div className="h-8 w-16 bg-gray-300 rounded"></div>
    </div>
    <div className="h-8 w-24 bg-gray-300 rounded mt-4"></div>
  </div>
);
